<template>
  <el-container>
    <el-main>
      <h2>万十科技股份有限公司</h2>
      <p>「To start your career ONCE again!」</p>
      <p>
        2022年以前我們是一群在日工作的工程師，在長年異地工作經驗之下，清楚瞭解跨文化差異導致生活或工作上的辛苦的一面，為了避免各位懷抱著來日本工作的台灣人在不了解日本業界生態下受到非正規公司的蒙騙，2022年9月我們懷抱著共同理想成立了万十科技股份有限公司。
      </p>
      <p>我們的目地是「提供一個合法及透明的管道，讓未來想跨國就業的夥伴們不須擔心落入求職陷阱，並且實現海內外短期輪調工作模式」而成立的教育、軟體顧問公司。</p>
      <p>公司除了在國際人才的支援外，也投身台日兩地企業客製化開發業務的銜接橋梁，並且與台灣學術單位共同合作，孕育年輕人投身科技產業的夢想。</p>

    </el-main>
  </el-container>
</template>

<script>
export default {
  name: 'IntroducePage'
}
</script>

<style scoped>
.img-box img {
  width: 100%;
}
.el-main p {
  line-height: 1.5;
  font-size: 1rem;
}
</style>



// WEBPACK FOOTER //
// src/pages/companypage/components/Introduce.vue